import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./api";

// Shared TanStack Query client. Tuned for a pentest tool where:
// - Background refetch on window focus is useful for live scan status
// - Don't retry on 4xx (user/auth errors should surface immediately)
// - Short stale time so dashboards feel live without hammering the API
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
      staleTime: 10_000,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: false,
    },
  },
});
